import React from "react";

const Menu = () => {
  return (
    <div>
      <h6 style={{backgroundColor:"red"}}>
        This is Menu Lorem ipsum dolor, sit amet consectetur adipisicing elit.
        Ipsa eligendi libero repellat porro dignissimos quaerat nam odio autem
        consequuntur officiis maxime ex nisi natus temporibus totam, similique
        incidunt tempora, ut illo suscipit excepturi ea error assumenda.
        Voluptatibus quis quia, laboriosam esse repudiandae, incidunt, inventore
        adipisci pariatur necessitatibus dignissimos atque beatae.
      </h6>
    </div>
  );
};

export default Menu;
